import {
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';

export const valueIncreaseDecrease = trigger('valueIncreaseDecrease', [
  transition(':increment', [
    style({ color: 'var(--value-increased)' }),
    animate('1300ms ease-in')
  ]),
  transition(':decrement', [
    style({ color: 'var(--value-decreased)' }),
    animate('1300ms ease-in')
  ])
]);

export const openClose = trigger('openClose', [
  state('open', style({ width: '*' })),
  state('closed', style({ width: 0 })),
  transition('* <=> *', [animate('0.25s ease-in-out')])
]);

export const valueIncreaseDecreasebg = trigger('valueIncreaseDecreasebg', [
  transition(':increment', [
    style({ 'background-color': 'var(--value-increased)' }),
    animate('700ms ease-in')
  ]),
  transition(':decrement', [
    style({ 'background-color': 'var(--value-decreased)' }),
    animate('700ms ease-in')
  ])
]);
